import type { App } from 'vue'
import router from '@/router'

export default {
  install(app: App<Element>) {
    app.use(router)
  },
}
